import { ListChecks } from "lucide-react";
import DeskConfirm from "@/components/crm/DeskConfirm";

/** Confirmation de suppression d'une étape (éditeur de type) — R2 (iter393). */
export default function ConfirmDeleteStepDialog({ open, onOpenChange, stepLabel = "", stepIndex = null, willNotifyCreator = true, onConfirm, busy = false }) {
  const num = stepIndex != null ? String(stepIndex).padStart(2, "0") : null;
  return (
    <DeskConfirm open={open} title="Supprimer cette étape ?" busy={busy} confirmLabel={busy ? "Suppression…" : "Supprimer l'étape"}
      message={<>L'étape et sa configuration seront perdues.{willNotifyCreator && <><br />Son créateur sera prévenu par email à la sauvegarde du type.</>}</>}
      onClose={() => { if (!busy) onOpenChange(false); }} onConfirm={onConfirm} testId="confirm-delete-step-dialog">
      <div className="flex items-center" style={{ gap: 10, padding: "8px 10px", borderRadius: 8, background: "#111114", border: "0.5px solid #2a2a30" }} data-testid="confirm-delete-step-block">
        {num && <span className="inline-flex items-center justify-center shrink-0 tabular-nums" style={{ width: 30, height: 30, borderRadius: 7, fontSize: 11.5, fontWeight: 700, color: "#5BA3F5", background: "#16273D" }}>{num}</span>}
        <ListChecks size={15} style={{ color: "#5BA3F5", flexShrink: 0 }} />
        <span className="truncate" style={{ fontSize: 12, color: "#E8E8EC" }} title={stepLabel} data-testid="confirm-delete-step-name">{stepLabel || "Étape sans nom"}</span>
      </div>
    </DeskConfirm>
  );
}
